// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3xax9","title":"BackImages_title__2ydJ7","images":"BackImages_images__2JUPJ"};